import { EntitlementConfiguration } from '@jupiterone/entitlement-types';
import gql from 'graphql-tag';
import { createUseQueryHook } from '../apollo/createUseQueryHook';

export const GetEntitlementConfiguration = gql`
  query getEntitlementConfiguration {
    getEntitlementConfiguration {
      featureEntitlements
      usageLimitEntitlements
      valueSetEntitlements
    }
  }
`;

type Variables = {};
type Response = {
  getEntitlementConfiguration: EntitlementConfiguration;
};

export const useEntitlementConfigurationQuery = createUseQueryHook<
  Response,
  Variables
>(GetEntitlementConfiguration);
